export default "__VITE_ASSET__BocAJigd__"